import { fetchWorkerChildCareFacilityDetails } from "../slice/workerChildCareFacilitiesSlice";
import WorkerHeader from "../../worker-header/components";
import WorkerFooter from "../../worker-footer/components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const WorkerChildCareFacilityDetails = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const { childCareFacilityDetails, loading, error } = useSelector(
        (state) => state.workerChildCareFacilities
    );

    const facilityLink = location.state?.facilityLink;

    useEffect(() => {
        if (facilityLink) {
            dispatch(fetchWorkerChildCareFacilityDetails(facilityLink));
        }
    }, [dispatch, facilityLink]);

    return (
        <>
            <WorkerHeader />
            <div className="container">
                <div className="col-md-8 col-xl-12 mt-4">
                    <div className="ps-2 ps-lg-4">
                        <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-3">
                            <h4 className="font-weight-bold text-primary font-size-40 line-hight-2 montserrat mb-0">
                                ChildCare Facility Details
                            </h4>
                            <button
                                className="btn btn-light-header"
                                onClick={() => navigate(-1)}
                            >
                                ← Back
                            </button>
                        </div>
                        <main className="container py-5">
                            {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>}
                            {error && <p className="text-danger">{error}</p>}

                            {!loading && !error && childCareFacilityDetails && (
                                <>
                                    <div className="row">
                                        {/* Left card: Basic Info */}
                                        <div className="col-md-4 mb-3">
                                            <div className="card shadow-sm h-100">
                                                <div className="card-body">
                                                    <table
                                                        className="table-bordered table-striped w-100"
                                                        style={{
                                                            borderCollapse: "collapse",
                                                            width: "100%",
                                                            tableLayout: "auto",
                                                        }}
                                                    >
                                                        <tbody>
                                                            {/* Facility Name and Street */}
                                                            <tr>
                                                                <td style={{ padding: "12px 15px" }}>
                                                                    <b>{childCareFacilityDetails.basicInfo?.name}</b>
                                                                    <br />
                                                                    {childCareFacilityDetails.basicInfo?.addressLine1}
                                                                </td>
                                                            </tr>

                                                            {/* City, State, ZIP */}
                                                            <tr>
                                                                <td style={{ padding: "12px 15px" }} valign="top" colSpan={2}>
                                                                    {childCareFacilityDetails.basicInfo?.addressLine2}
                                                                </td>
                                                            </tr>

                                                            {/* Directions Link */}
                                                            {childCareFacilityDetails.basicInfo?.directionsLink && (
                                                                <tr>
                                                                    <td style={{ padding: "12px 15px" }} valign="top" align="left" colSpan={2}>
                                                                        <a
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            href={childCareFacilityDetails.basicInfo.directionsLink}
                                                                            style={{ display: "flex", alignItems: "center" }}
                                                                        >
                                                                            <img
                                                                                src="/assets/images/map_directions.png"
                                                                                alt="Google Maps Icon"
                                                                                style={{ marginRight: "8px" }}
                                                                            />
                                                                            Directions
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>


                                                </div>
                                            </div>
                                        </div>


                                        {/* Right card: Details */}
                                        <div className="col-md-8 mb-3">
                                            <div className="card shadow-sm h-100">
                                                <div className="card-body">

                                                    <table
                                                        className="table-bordered w-100 table-striped"
                                                        style={{ borderCollapse: "collapse" }}
                                                    >
                                                        <tbody>
                                                            {Object.entries(childCareFacilityDetails.details || {}).map(
                                                                ([key, value]) => {
                                                                    // Strip HTML tags from the key
                                                                    const cleanKey = key.replace(/<[^>]+>/g, '').trim();

                                                                    // Strip HTML tags from the value
                                                                    const cleanValue = value.replace(/<[^>]+>/g, '').trim();

                                                                    return (
                                                                        <tr key={cleanKey}>
                                                                            <td style={{ padding: "12px 15px", width: "30%" }}>
                                                                                <strong>{cleanKey}</strong>
                                                                            </td>
                                                                            <td style={{ padding: "12px 15px" }}>
                                                                                {cleanValue}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                    {childCareFacilityDetails.inspectionHistory?.length > 0 && (
                                        <>
                                            <hr />
                                            <h5 className="mt-4 mb-3 text-primary">Inspection History</h5>

                                            <div className="table-responsive">
                                                <table className="table table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            {Object.keys(childCareFacilityDetails.inspectionHistory[0]).map(
                                                                (header) => (
                                                                    <th key={header}>
                                                                        {header.replace(/<[^>]+>/g, '')}
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {childCareFacilityDetails.inspectionHistory.map((row, index) => (
                                                            <tr key={index}>
                                                                {Object.values(row).map((value, i) => (
                                                                    <td key={i}>{value}</td>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )}

                                </>
                            )}
                        </main>
                    </div>
                </div>
            </div>
            <WorkerFooter />
        </>
    );
};

export default WorkerChildCareFacilityDetails;
